import { render } from "./BaseFooter.vue?vue&type=template&id=3ca99283&scoped=true"
import script from "./BaseFooter.vue?vue&type=script&lang=js"
export * from "./BaseFooter.vue?vue&type=script&lang=js"

import "./BaseFooter.vue?vue&type=style&index=0&id=3ca99283&lang=scss&scoped=true"

import exportComponent from "E:\\_projekte\\PRIGNITZMUSEUM_HAVELBERG\\ARCHITEKTURSPUR\\release\\architekturspur\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca99283"]])

export default __exports__